import { omit, safeEval } from '@showroomjs/core';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import * as tslib from 'tslib';
import { useCodeImports } from '../lib/code-imports-context';
import { useCodeVariables } from '../lib/code-variables-context';
import { prerenderExample } from '../lib/config';
import { useCustomUseState } from '../lib/use-custom-state';
import { useConsole, noopConsole } from '../lib/use-preview-console';
export const CodePreview = (props) => {
    const codeVariables = useCodeVariables();
    const imports = useCodeImports();
    const previewConsole = useConsole();
    const useCustomState = useCustomUseState();
    const evalCode = React.useCallback((code, options) => safeEval(code, 
    // omit variables that has already been imported to avoid conflict.
    omit(Object.assign(Object.assign({}, codeVariables), { showroomUseState: React.useState, React: Object.assign({}, React, { useState: useCustomState }), ReactDOM, render: options.render, tslib, imports: options.imports, console: options.skipConsole
            ? Object.assign({}, previewConsole, noopConsole)
            : previewConsole }), options.importNames)), []);
    const [ui, setUi] = React.useState(() => {
        if (!prerenderExample || !props.code) {
            return null;
        }
        let result = null;
        evalCode(props.code, {
            importNames: props.importNames,
            imports: props.imports || imports,
            render: (ui) => {
                result = ui;
            },
            skipConsole: props.skipConsoleForInitialRender,
        });
        return result;
    });
    React.useEffect(() => {
        let isLatest = true;
        evalCode(props.code, {
            importNames: props.importNames,
            imports: props.imports || imports,
            render: (newUi) => {
                if (isLatest) {
                    setUi(newUi);
                }
            },
        });
        return () => {
            isLatest = false;
        };
    }, [props.code]);
    return ui;
};
//# sourceMappingURL=code-preview.js.map